import homeReducer from './reducers';
import * as allHomeActions from './actions';

export { default as homeOperations } from './operations';
export { default as homeTypes } from './types';
export const homeActions = allHomeActions;
export default homeReducer;
